export const taskList = [
  {
    value: 'task1',
    label: 'Task 1',
    count: 1,
  },
  {
    value: 'task2',
    label: 'Task 2',
    count: 2,
  },
  {
    value: 'task3',
    label: 'Task 3',
    count: 3,
  },
  {
    value: 'task4',
    label: 'Task 4',
    count: 4,
  },
]

export const life = 10000

export const admins = ['ADMIN']

export const WEB_APP_NAME = process.env.REACT_APP_NAME
  ? process.env.REACT_APP_NAME
  : 'Range Change App'

export const routes = {
  DEFAULT: '/commercial-webapp',
  DASHBOARD: '/dashboard',
  DASHBOARD_PENDINGACTION: '/user/pendingactions',
  DASHBOARD_PENDINGACTIONS_UPDATE: '/user/pendingactionsupdate',
  DASHBOARD_UNASSIGNWORKFLOW: '/user/unassignworkflow',
  DASHBOARD_INPROGRESSTASK: '/user/inprogresstasks',
  DASHBOARD_MYGROUPPENDINGTASKS: '/user/mygrouppendingactions',
  DASHBOARD_RANGE_PENDINGACTION: '/event/pendingactions',
  DASHBOARD_RANGE_PENDINGACTION_WEEK5: '/event/week-5',
  DASHBOARD_RANGE_PENDINGACTION_WEEK2_TO_WEEK5: '/event/week-2-week5',
  DASHBOARD_RANGE_PENDINGACTION_NEXT_WEEK: '/event/nextweek',
  DASHBOARD_RANGE_PENDINGACTION_CURRENT_WEEK: '/event/currentweek',
  DASHBOARD_RAF_CT06: '/event/raf',
  DASHBOARD_RANGE_MYGROUPPENDINGTASKS: '/event/mygrouppendingactions',
  DASHBOARD_RANGE_MYGROUP_WEEK5: '/event/mygroupweek-5',
  DASHBOARD_RANGE_MYGROUP_WEEK2_TO_WEEK5: '/event/mygroupweek-2-week5',
  DASHBOARD_RANGE_MYGROUP_NEXT_WEEK: '/event/mygroupnextweek',
  DASHBOARD_RANGE_MYGROUP_CURRENT_WEEK: '/event/mygroupcurrentweek',
  DASHBOARD_RANGE_MYTASKREJECTED: '/event/mytaskrejected',
  DASHBOARD_RANGE_MISSED: '/event/missed',
  DASHBOARD_RANGE_MYGROUPTASKREJECTED: '/event/grouptaskrejected',
  DASHBOARD_RANGE_MYGROUPTASK_MISSED: '/event/grouptaskmissed',
  RANGEAMEND: '/rangeamend',
  PROMOFUNDNG: '/promofunding',
  RETAILPRICE: '/retailprice',
  SUPPLIERPORT: '/supplierport',
  PRODUCTPORT: '/productport',
  USERCONFIG: '/userconfig',
  USERCONFIG_USERCREATE: `/userconfig/usercreate`,
  USERCONFIG_USERMANAGE: `/userconfig/usermanage`,
  USERCONFIG_USERGROUP: `/userconfig/usergroup`,
  USERCONFIG_GROUPCREATE: `/userconfig/groupcreate`,
  USERCONFIG_GROUPUPDATE: `/userconfig/groupupdate`,
  USERCONFIG_USERUPDATE: `/userconfig/userupdate`,
  // EVENT_BULK_UPLOAD: '/rangeamend/eventupload',
  // EVENT_CREATE:'/rangeamend/createevent',
  // EVENT_MANAGE: '/rangeamend/eventmanage'
  RANGEAMEND_EVENTDASH: '/rangeamend/evntdashboard',
  RANGEAMEND_MANAGE: '/rangeamend/manageevent',
  RANGEAMEND_DELIST: '/rangeamend/delistltr',
  RANGEAMEND_CREATE: '/rangeamend/eventcreate',
  RANGEAMEND_MANAGE_TASK: '/rangeamend/manageeventtask',
  RANGEAMEND_RAISE_EXCEPTIONS: '/rangeamend/raiseexceptions',
  RANGEAMEND_RAISE_EXCEPTIONS_UPDATE: '/rangeamend/exception-update',
  RANGEAMEND_MANAGE_EXCEPTION_TASK: '/rangeamend/manage-exception-task',
}

export const extensions = [
  '.jpg',
  '.jpeg',
  '.jpe',
  '.jif',
  '.jfif',
  '.jfi',
  '.png',
  '.gif',
  '.webp',
  '.tiff',
  '.tif',
  '.psd',
  '.raw',
  '.arw',
  '.cr2',
  '.nrw',
  '.k25',
  '.bmp',
  '.dib',
  '.heif',
  '.heic',
  '.ind',
  '.indd',
  '.indt',
  '.jp2',
  '.j2k',
  '.jpf',
  '.jpx',
  '.jpm',
  '.mj2',
  '.svg',
  '.svgz',
  '.ai',
  '.eps',
  '.pdf',
  '.doc',
  '.docx',
  '.html',
  '.htm',
  '.odt',
  '.xls',
  '.xlsx',
  '.ods',
  '.ppt',
  '.pptx',
  '.txt',
  '.xls',
  '.xlsx',
  '.csv',
  '.xlsm',
]
export const extensionsForCT14to17 = ['.jpg', '.jpeg', '.png', '.pdf']

export const bulkUploadFileType = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
]

export const excelUploadFileExtns =
  '.csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel.sheet.macroEnabled.12'

export const DEFAULT_CHUNK_SIZE = 50

export const DEFAULT_PUBLISH_EVENTS_CHUNK_SIZE = 100
